import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "signup-loader"
}
const _hoisted_2 = { class: "signup-view" }
const _hoisted_3 = {
  key: 0,
  id: "signup"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 11 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0.787794 0.000340998C0.631812 0.000381975 0.479387 0.0469545 0.350004 0.134104C0.220621 0.221254 0.120161 0.345022 0.0614663 0.489583C0.00277158 0.634145 -0.0114904 0.792932 0.0205036 0.945644C0.0524977 1.09836 0.129294 1.23805 0.241074 1.34688L4.39124 5.49832L0.241074 9.64975C0.165823 9.72203 0.105743 9.80859 0.0643549 9.90438C0.0229668 10.0002 0.00110191 10.1033 4.05857e-05 10.2076C-0.00102073 10.312 0.018743 10.4155 0.0581743 10.5121C0.0976055 10.6087 0.155912 10.6965 0.229678 10.7702C0.303444 10.844 0.391188 10.9024 0.48777 10.9418C0.584352 10.9812 0.687831 11.001 0.792147 11C0.896463 10.9989 0.999519 10.977 1.09528 10.9356C1.19104 10.8942 1.27758 10.8341 1.34983 10.7588L5.5 6.60741L9.65017 10.7588C9.72242 10.8341 9.80896 10.8942 9.90472 10.9356C10.0005 10.977 10.1035 10.9989 10.2078 11C10.3122 11.001 10.4156 10.9812 10.5122 10.9418C10.6088 10.9024 10.6966 10.844 10.7703 10.7703C10.8441 10.6965 10.9024 10.6087 10.9418 10.5121C10.9813 10.4155 11.001 10.312 11 10.2076C10.9989 10.1033 10.977 10.0002 10.9356 9.90438C10.8943 9.80859 10.8342 9.72203 10.7589 9.64975L6.60875 5.49832L10.7589 1.34688C10.8722 1.23671 10.9496 1.09487 10.9809 0.939949C11.0123 0.785028 10.9961 0.624253 10.9345 0.478692C10.8729 0.333131 10.7688 0.209576 10.6358 0.124218C10.5028 0.0388602 10.3472 -0.00431821 10.1892 0.000340998C9.98552 0.00641261 9.79218 0.0915746 9.65017 0.237785L5.5 4.38922L1.34983 0.237785C1.27676 0.16265 1.18938 0.102928 1.09284 0.0621449C0.99631 0.0213623 0.892584 0.000347109 0.787794 0.000340998Z",
    fill: "black"
  })
], -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "title g-heading-small flex-end" }, "Sign Up", -1)
const _hoisted_7 = { class: "input-container" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("ul", { class: "password-reqs g-body-text-small" }, [
  /*#__PURE__*/_createElementVNode("li", null, "Password must be 6 characters long")
], -1)
const _hoisted_9 = {
  key: 1,
  class: "error flex-center",
  id: "error"
}
const _hoisted_10 = { class: "signup-btn-container" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 0,
  class: "login-container"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "left flex-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "heading" }, "Hello Again"),
  /*#__PURE__*/_createElementVNode("div", { class: "sub-headings" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "sub-heading" }, "Lets get you ready for"),
    /*#__PURE__*/_createElementVNode("span", { class: "sub-heading" }, "your next adventure")
  ])
], -1)
const _hoisted_14 = { class: "right flex-left" }
const _hoisted_15 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DotDotDot = _resolveComponent("DotDotDot")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_DotDotDot)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_Transition, {
        name: "input",
        mode: "out-in",
        appear: ""
      }, {
        default: _withCtx(() => [
          true
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                ($setup.isMobile)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "close",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('done')))
                    }, _hoisted_5))
                  : _createCommentVNode("", true),
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _withDirectives(_createElementVNode("input", {
                    class: "email g-btn-text",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.email) = $event)),
                    type: "text",
                    placeholder: "Email"
                  }, null, 512), [
                    [_vModelText, $setup.email]
                  ]),
                  _createVNode($setup["PasswordInput"], {
                    class: "password g-btn-text",
                    id: "password",
                    modelValue: $setup.password,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.password) = $event)),
                    placeholder: "Password",
                    "allow-show": true
                  }, null, 8, ["modelValue"]),
                  _createVNode($setup["PasswordInput"], {
                    class: "password g-btn-text",
                    id: "verify",
                    modelValue: $setup.verifyPassword,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.verifyPassword) = $event)),
                    placeholder: "Verify Password",
                    "allow-show": true
                  }, null, 8, ["modelValue"]),
                  _hoisted_8
                ]),
                ($setup.error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString($setup.error), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("button", {
                    class: "g-btn-text signin",
                    disabled: $setup.loading || !$setup.canSubmit,
                    onClick: $setup.performSignup
                  }, "Sign Up", 8, _hoisted_11)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_Transition, {
        name: "sign",
        mode: "out-in",
        appear: ""
      }, {
        default: _withCtx(() => [
          true
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("button", {
                    class: "signin g-btn-text",
                    disabled: $setup.loading,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('moveToLogin')))
                  }, "Sign In", 8, _hoisted_15)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ], 64))
}